module.exports = __webpack_public_path__ + "img/italy-external-causes-female.40cada6c.png";